import Store from '../Store';

const MarketEmployeeStore = new Store('markets/employees');


export {MarketEmployeeStore};